import { useState } from "react";
import { MainBox } from "../components/mainBox";
import { MapLiquidityToIndex, MapIndexToLiquidity } from "./helpers/MapData";
import { UserMessageComponent } from "../components/message/UserMessageComponent";
import { IPageProps } from "@portal/types/robot/IPageProps";
import { RobotTextResources } from "@portal/assets/text/RobotTextResources";
import { SelectionBoxComponent } from "../components/selectionBox/SelectionBoxComponent";
import { RobotFooterComponent, RobotNavigateToPage } from "../components/footer";
import { TextLine } from "@portal/components/atoms/v2/textLine";
import Typography from "@portal/components/atoms/v2/typography";
import { useRobot } from "@portal/app/context/robotProvider";
import { useRouter } from "next/navigation";
import { useSession } from "@portal/auth/client/SessionProvider";

export const LiquidityPage = ({ centerId, pageIndex, isDefaultLanguage }: IPageProps) => {
  const { riskLevelRequest, setAvailableLiquidity } = useRobot();
  const [showUserMessage, setShowUserMessage] = useState(false);
  const router = useRouter();
  const { session } = useSession();
  const isLoggedIn = session?.status === "authenticated";

  const texts = isDefaultLanguage ? RobotTextResources.primary : RobotTextResources.secondary;
  const options = [texts.PAGE_8_A, texts.PAGE_8_B, texts.PAGE_8_C, texts.PAGE_8_D];

  const OnSelectionClick = (selectedOption: number) => {
    if (selectedOption === 0) {
      setShowUserMessage(true);
      return;
    }
    const result = MapIndexToLiquidity(selectedOption);
    if (result !== null) setAvailableLiquidity(result);
  };

  return (
    <>
      <MainBox>
        <Typography variant="H6">{texts.PAGE_8_SUBHEADER}</Typography>
        <TextLine />
        <SelectionBoxComponent
          options={options}
          selectedOption={MapLiquidityToIndex(riskLevelRequest.availableLiquidity) ?? -1}
          onSelectionClick={OnSelectionClick}
        />
      </MainBox>
      {showUserMessage && (
        <UserMessageComponent
          userMessage={texts.MESSAGE_NO_FUND_FOR_YOU}
          showDialog={showUserMessage}
          secondaryButtonText={texts.MESSAGE_CHANGE_REPLY}
          secondaryButtonClick={() => {
            setShowUserMessage(false);
          }}
        />
      )}
      <RobotFooterComponent
        pageIndex={pageIndex}
        centerId={centerId}
        primaryButtonText={texts.BUTTON_NEXT}
        secondaryButtonText={texts.BUTTON_BACK}
        secondaryButtonClickOverride={() => {
          const newPageIndex = riskLevelRequest.sustainability ? pageIndex - 1 : pageIndex - 2;
          const newUrl = RobotNavigateToPage(isLoggedIn ?? false, newPageIndex, centerId);
          router.push(newUrl);
        }}
        disabled={riskLevelRequest.availableLiquidity === null}
      />
    </>
  );
};
